import { Box, Typography } from '@mui/material';
import { SecondaryButton } from 'sharedComponents/Buttons/SecondaryButton';
import { LoadingSpinner } from 'sharedComponents/LoadingSpinner/loadingSpinner';

interface LoadMoreButtonProps {
  onClick: () => void;
  isLoading: boolean;
  hasMore: boolean;
  totalLoaded: number;
  totalCount: number;
  dataTestId: string;
}

/**
 * LoadMoreButton component for pagination functionality
 * Shows a "Load More" button when there are more items to load,
 * or a completion message when all items are loaded
 */
export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  onClick,
  isLoading,
  hasMore,
  totalLoaded,
  totalCount,
  dataTestId,
}) => (
  <Box sx={{ textAlign: 'center', py: 2 }}>
    {isLoading ? (
      <LoadingSpinner dataTestId={`${dataTestId}-loading`} size={12} />
    ) : hasMore ? (
      <SecondaryButton onClick={onClick} disabled={isLoading} dataTestId={dataTestId}>
        {`Load More (${totalLoaded} of ${totalCount})`}
      </SecondaryButton>
    ) : (
      <Typography variant="body2" color="text.secondary" data-testid={`${dataTestId}-complete`}>
        Showing all {totalCount} hiring requests
      </Typography>
    )}
  </Box>
);
